module.exports = __webpack_public_path__ + "img/cloud-download.8cb47d46.svg";